import { PaymentOrchestrationError } from "./PaymentOrchestrationError";
import { PaymentErrorCategories } from "./PaymentErrorCategories";

/**
 * Error thrown when payment configuration is invalid or missing.
 * This typically indicates missing API keys, invalid venue setup, etc.
 * Usually not recoverable without admin intervention.
 */
export class PaymentConfigurationError extends PaymentOrchestrationError {
  readonly category = PaymentErrorCategories.CONFIGURATION;
  readonly recoverable = false;

  constructor(
    technicalMessage: string,
    options?: {
      userMessage?: string;
      metadata?: Record<string, unknown>;
    }
  ) {
    super(technicalMessage, {
      userMessage:
        options?.userMessage ||
        "Payment processing is temporarily unavailable. Please try again or contact support.",
      metadata: options?.metadata,
    });
  }
}
